import SubDefaultLayout from "../../components/SubDefaultLayout";
import { Button, Card, Checkbox, Col, Input, Row, Select, Typography } from "antd";
import { StyleSheet } from "../../StyleSheet";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { useCallback, useEffect, useState } from "react";
import { AppDispatch } from "../../stores/store";
import _ from "lodash";
import Loading from "../../components/Loading";
import { addBillingData, getInvoiceData, updateBillingData } from "../../methods/Methods";
import { ResponseBillingData, ResponseBillingDataListaCFDI, ResponseBillingDataListaRegFiscal } from "../../types/common";
import InfoCardComponent from "../../components/InfoCardComponent";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
const { Text } = Typography;

const BillingData = () => {
    const dispatch = useDispatch<AppDispatch>();
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [rfc, setRfc] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [streetAndNumber, setStreetAndNumber] = useState("");
    const [suburb, setSuburb] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [email, setEmail] = useState("");
    const [emailValid, setEmailValid] = useState(true);
    const [rfcValid, setRfcValid] = useState(true);
    const [cfdi, setCfdi] = useState("");
    const [regime, setRegime] = useState("");
    const [checkGenerateInvoice, setCheckGenerateInvoice] = useState(false);
    const [checkSendInvoice, setCheckSendInvoice] = useState(false);
    const [checkTermsAndCond, setCheckTermsAndCond] = useState(false);
    const [billingData, setBillingData] = useState<ResponseBillingData>();
    const [listOfCFDI, setListOfCFDI] = useState<Array<ResponseBillingDataListaCFDI>>([]);
    const [listOfTaxsRegimens, setListOfTaxsRegimens] = useState<Array<ResponseBillingDataListaRegFiscal>>([]);
    const [hasError, setHasError] = useState(false);
    const [isToUpdate, setIsToUpdate] = useState(false);
    const [message, setMessage] = useState("");

    // Función para validar si el formulario es válido.
    const validateForm = (): Boolean => {
        if ((rfcValid && emailValid) && !_.isEmpty(businessName) && !_.isEmpty(cfdi) &&
            !_.isEmpty(regime)) {
            return true;
        }
        return false;
    }

    // Función para agregar o modificar datos de facturación.
    const addOrModifyBillingData = async () => {
        setLoading(true);
        let typeAlert = "";
        let messageAlert = "";
        // Se pregunta si el formulario no es válido.
        if (!validateForm()) {
            messageAlert = "Hay campos incompletos en el formulario."
            typeAlert = "ERROR";
            let dispatchAlert: AlertSliceInterface = {
                show: true,
                type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                title: "¡Estimado Usuario!",
                message: messageAlert,
                onFinalize: () => handleDispatchAlertModal()
            }
            openAlertModal(dispatchAlert);
            setLoading(false);
        } else {
            // Objecto para agregar los dastos de facturacion.
            let requestBodyAddBillingData = {
                "razonSocial": businessName,
                "domicilio": streetAndNumber,
                "colonia": suburb,
                "ciudad": city,
                "estado": state,
                "codigoPostal": postalCode,
                "rfc": rfc.toUpperCase(),
                "correo": email,
                "id_usoCFDI": cfdi,
                "id_regfiscal": regime
            }
            // Objecto para actualizar los datos de facturacion.
            let requestBodyUpdateBillingData = {
                "razonSocial": businessName,
                "domicilio": streetAndNumber,
                "colonia": suburb,
                "ciudad": city,
                "estado": state,
                "codigoPostal": postalCode,
                "rfc": rfc.toUpperCase(),
                "generarFactura": checkGenerateInvoice ? "1" : "0",
                "enviarFactura": checkSendInvoice ? "1" : "0",
                "correo": email,
                "id_usoCFDI": cfdi,
                "id_regfiscal": regime
            }
            // Se pregunta si es para actualizar datos o agregarlos.
            if (isToUpdate) {
                // Se actualizan los datos.
                await updateBillingData(requestBodyUpdateBillingData, idCliente)
                    .then((response) => {
                        typeAlert = "SUCCESS";
                        messageAlert = "Actualización de datos EXITOSA.";
                        let dispatchAlert: AlertSliceInterface = {
                            show: true,
                            type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                            title: "Datos de Facturación",
                            message: messageAlert,
                            onFinalize: () => handleDispatchAlertModal()
                        }
                        openAlertModal(dispatchAlert);
                        setLoading(false);
                    })
                    .catch(() => {
                        typeAlert = "ERROR";
                        messageAlert = "Hubo un error al procesar su solicitud. \nIntente más tarde.";
                        let dispatchAlert: AlertSliceInterface = {
                            show: true,
                            type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                            title: "¡Estimado Usuario!",
                            message: messageAlert,
                            onFinalize: () => handleDispatchAlertModal()
                        }
                        openAlertModal(dispatchAlert);
                        setLoading(false);
                    })
            } else {
                // Se agregan los datos.
                await addBillingData(requestBodyAddBillingData, idCliente)
                    .then((response) => {
                        typeAlert = "SUCCESS";
                        messageAlert = "Registro de Datos Exitoso.";
                        let dispatchAlert: AlertSliceInterface = {
                            show: true,
                            type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                            title: "Datos de Facturación.",
                            message: messageAlert,
                            onFinalize: () => handleDispatchAlertModal()
                        }
                        openAlertModal(dispatchAlert);
                        setLoading(false);
                    })
                    .catch(() => {
                        typeAlert = "ERROR";
                        messageAlert = "Hubo un error al procesar su solicitud. \nIntente más tarde.";
                        let dispatchAlert: AlertSliceInterface = {
                            show: true,
                            type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                            title: "¡Estimado Usuario!",
                            message: messageAlert,
                            onFinalize: () => handleDispatchAlertModal()
                        }
                        openAlertModal(dispatchAlert);
                        setLoading(false);
                    })
            }
        }
    };

    const invoiceData = useCallback(async () => {
        if (idCliente) {
            setLoading(true);
            await getInvoiceData(idCliente)
                .then((response) => {
                    setBillingData(response.data.data[0]);
                    if (response.data.data[0].listaCFDI?.length > 0 && response.data.data[0].listaRegFiscal?.length > 0) {
                        setListOfCFDI(response.data.data[0].listaCFDI);
                        setListOfTaxsRegimens(response.data.data[0].listaRegFiscal);
                        setHasError(false);
                    } else {
                        setHasError(true);
                        setMessage("No fue posible obtener la información.\nIntente de nuevo más tarde.");
                    }
                    setLoading(false);
                })
                .catch(() => {
                    setHasError(true);
                    setMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.");
                    setLoading(false);
                })
        }
    }, [idCliente]);

    const validateRfc = (inputString: string) => {
        let valid = false;
        let reg =
            inputString.length === 12
                ? "^(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))"
                : "^(([A-Z]|[a-z]|s){1})(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
        let regRFC = new RegExp(reg);
        let result = regRFC.test(inputString);
        if (result) valid = true;
        else valid = false;
        return valid;
    };

    const handleChangeRfc = (value: string) => {
        setRfc(value);
        let isRfcValid = validateRfc(value);
        if (isRfcValid) {
            setRfcValid(true);
        } else {
            setRfcValid(false);
        }
    };

    const handleChangeEmail = (value: string) => {
        setEmail(value);
        let isEmailValid = validateEmail(value);
        if (isEmailValid) {
            setEmailValid(true);
        } else {
            setEmailValid(false);
        }
    };

    const validateEmail = (inputString: string) => {
        let valid = false;
        var reg = RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.([a-zA-Z]{2,4})+$");
        var result = reg.test(inputString);
        if (result) {
            valid = true;
        } else {
            valid = false;
        }
        return valid;
    };

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal +
                generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        invoiceData();
    }, [invoiceData])

    useEffect(() => {
        if (idCliente) {
            if (billingData && !billingData.estatus) {
                setBusinessName(billingData.razonSocial);
                setStreetAndNumber(billingData.domicilio);
                setSuburb(billingData.colonia);
                setCity(billingData.ciudad);
                setState(billingData.estado);
                setPostalCode(billingData.codigoPostal);
                setRfc(billingData.rfc);
                setCheckGenerateInvoice(billingData.generarFactura === 1 ? true : false);
                setCheckSendInvoice(billingData.enviarFactura === 1 ? true : false);
                setEmail(billingData.correo);
                setCfdi(billingData.idCFDI);
                setRegime(billingData.idRegFiscal);
                setRfcValid(true);
                setEmailValid(true);
                setIsToUpdate(true);
            }
            else if (billingData && billingData.estatus) {
                setBusinessName("");
                setStreetAndNumber("");
                setSuburb("");
                setCity("");
                setState("");
                setPostalCode("");
                setRfc("");
                setCheckGenerateInvoice(false);
                setCheckSendInvoice(false);
                setEmail("");
                setCfdi("");
                setRegime("");
                setRfcValid(false);
                setEmailValid(false);
                setIsToUpdate(false);
            }
        }
    }, [billingData, idCliente]);

    return (
        <>
            {
                loading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Datos de Facturación"} needReturn={true} navigateTo="/billing">
                        {
                            hasError ? (
                                <InfoCardComponent title="¡Atención!" description={message} />
                            ) : (
                                <Card style={{ ...styles.cardRoot }}>
                                    <Row gutter={[16, 16]} style={{ marginTop: 5 }}>
                                        <Col xs={24} xl={8}>
                                            <div>
                                                <Text style={styles.inputTitle}>R.F.C.</Text>
                                                <Input
                                                    value={rfc}
                                                    maxLength={13}
                                                    style={styles.inputText}
                                                    onChange={(event) => handleChangeRfc(event?.target.value)}
                                                    status={!rfcValid ? "error" : ""}
                                                />
                                                {<Text type="danger" style={styles.emptyFieldError}>{!rfcValid ? "El formato del rfc es invalido" : ""}</Text>}
                                            </div>
                                        </Col>
                                        <Col xs={24} xl={8}>
                                            <div>
                                                <Text style={styles.inputTitle}>Razón Social</Text>
                                                <Input
                                                    value={businessName}
                                                    style={styles.inputText}
                                                    onChange={(event) => setBusinessName(event.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={24} xl={8}>
                                            <div>
                                                <Text style={styles.inputTitle}>Calle y Número</Text>
                                                <Input
                                                    value={streetAndNumber}
                                                    style={styles.inputText}
                                                    onChange={(evant) => setStreetAndNumber(evant.target.value)}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
                                        <Col xs={24} xl={8}>
                                            <div>
                                                <Text style={styles.inputTitle}>Colonia</Text>
                                                <Input
                                                    value={suburb}
                                                    style={styles.inputText}
                                                    onChange={(evant) => setSuburb(evant.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={24} xl={8}>
                                            <div>
                                                <Text style={styles.inputTitle}>Ciudad</Text>
                                                <Input
                                                    value={city}
                                                    style={styles.inputText}
                                                    onChange={(evant) => setCity(evant.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={24} xl={8}>
                                            <div>
                                                <Text style={styles.inputTitle}>Estado</Text>
                                                <Input
                                                    value={state}
                                                    style={styles.inputText}
                                                    onChange={(evant) => setState(evant.target.value)}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
                                        <Col xs={24} xl={8}>
                                            <div>
                                                <Text style={styles.inputTitle}>Código Postal</Text>
                                                <Input
                                                    value={postalCode}
                                                    style={styles.inputText}
                                                    onChange={(evant) => setPostalCode(evant.target.value)}
                                                    maxLength={5}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={24} xl={8}>
                                            <div>
                                                <Text style={styles.inputTitle}>Correo Electrónico</Text>
                                                <Input
                                                    value={email}
                                                    style={styles.inputText}
                                                    status={!emailValid ? "error" : ""}
                                                    onChange={(event) => handleChangeEmail(event?.target.value)}
                                                />
                                                {<Text type="danger" style={styles.emptyFieldError}>{!emailValid ? "El formato del correo es invalido" : ""}</Text>}
                                            </div>
                                        </Col>
                                        <Col xs={24} xl={8}>
                                            <div>
                                                <Text style={styles.inputTitle}>Uso de Comprobantes</Text>
                                                <Select
                                                    style={styles.selectText}
                                                    bordered={true}
                                                    placeholder="Uso de CFDI"
                                                    notFoundContent="No se encontraron datos"
                                                    value={cfdi}
                                                    onChange={(selectedItem) => setCfdi(selectedItem)}
                                                    options={listOfCFDI.map((data) => ({
                                                        value: data.id,
                                                        label: data.descripcion,
                                                    }))}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
                                        <Col xs={24} xl={8}>
                                            <div>
                                                <Text style={styles.inputTitle}>Régimen Fiscal</Text>
                                                <Select
                                                    style={styles.selectText}
                                                    placeholder="Régimen Fiscal"
                                                    notFoundContent="No se encontraron datos"
                                                    value={regime}
                                                    onChange={(selectedItem) => setRegime(selectedItem)}
                                                    options={listOfTaxsRegimens.map((data) => ({
                                                        value: data.id,
                                                        label: data.descripcion,
                                                    }))}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={24} xl={8} style={styles.checkBilling}>
                                            <div>
                                                <Checkbox
                                                    onChange={() => setCheckGenerateInvoice(!checkGenerateInvoice)}
                                                    checked={checkGenerateInvoice}
                                                >
                                                    <Text>
                                                        Generar Factura
                                                    </Text>
                                                </Checkbox>
                                            </div>
                                        </Col>
                                        <Col xs={24} xl={8} style={styles.checkBilling}>
                                            <div>
                                                <Checkbox
                                                    onChange={() => setCheckSendInvoice(!checkSendInvoice)}
                                                    checked={checkSendInvoice}
                                                >
                                                    <Text>
                                                        Enviar Factura
                                                    </Text>
                                                </Checkbox>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: 15 }}>
                                        <Col xs={24} xl={9} style={styles.checkBilling}>
                                            <div>
                                                <Checkbox
                                                    onChange={() => setCheckTermsAndCond(!checkTermsAndCond)}
                                                    checked={checkTermsAndCond}
                                                >
                                                    <Text>
                                                        Acepto Términos y condiciones
                                                    </Text>
                                                </Checkbox>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: 30 }}>
                                        <Col xs={24} xl={16} >
                                            <Text style={{ fontSize: 13 }}>
                                                La aceptación de la presente implica su consentimiento y autorización
                                                expresa para el tratamiento de sus datos personales según lo contenido
                                                en el&nbsp;
                                                <Text
                                                    style={styles.textLink}
                                                    onClick={() => (window.open("https://www.megacable.com.mx/telefonia"))}
                                                >
                                                    aviso de privacidad
                                                </Text>
                                                &nbsp;de Mega
                                            </Text>
                                        </Col>
                                        <Col xs={24} xl={8} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 10 }}>
                                            <Button
                                                style={!checkTermsAndCond ? styles.buttonDisabled : styles.buttonFinal}
                                                type="primary"
                                                onClick={() => addOrModifyBillingData()}
                                                disabled={!checkTermsAndCond}
                                            >
                                                {
                                                    isToUpdate ? "Actualizar" : "Guardar"
                                                }
                                            </Button>
                                        </Col>
                                    </Row>
                                </Card>
                            )
                        }
                    </SubDefaultLayout>
            }
        </>
    );
};

const styles = StyleSheet.create({
    cardRoot: {
        backgroundColor: "white",
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20,
    },
    textLink: {
        marginTop: 10,
        cursor: "pointer",
        textDecoration: "underline",
        color: "#287dd2"
    },
    buttonFinal: {
        backgroundColor: '#0055c2',
        borderRadius: 30,
        color: 'white',
        border: "none",
        padding: "5px 30px",
        height: 35
    },
    buttonDisabled: {
        backgroundColor: "#787B7F",
        borderRadius: 30,
        color: 'white',
        border: "none",
        padding: "5px 30px",
        height: 35
    },
    inputText: {
        marginTop: 15,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    selectText: {
        marginTop: 15,
        width: '100%',
        fontSize: 12
    },
    emptyFieldError: {
        fontSize: 11
    },
    checkBilling: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 25,
        justifyContent: 'center'
    }
});

export default BillingData;
